import { ArrayField, ArrayInput, BooleanField, Button, Create, Datagrid, DateField, DateTimeInput, Edit, List, NumberField, NumberInput, SimpleForm, SimpleFormIterator, Toolbar, TopToolbar, useDataProvider, useNavigate, useNotify, useRecordContext, useRedirect, useRefresh } from "react-admin";
import { Delete, Add } from "@mui/icons-material";

const DeleteAppointmentButton = ({ appointmentId, scheduleId, isSignedUp, appointmentDatetimeUtcString }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleDelete = async () => {
        if (window.confirm('Вы уверены, что хотите удалить эту запись?')) {
            try {
                await dataProvider.delete('appointments', {
                    id: appointmentId,
                    // Если нужно передать schedule_id
                    data: { schedule_id: scheduleId }
                });
                notify('Запись успешно удалена', { type: 'success' });
                refresh(); // Обновляем страницу
            } catch (error) {
                console.error('Error deleting appointment:', error);
                notify('Ошибка при удалении записи', { type: 'error' });
            }
        }
    };

    const appointmentDatetime = new Date(appointmentDatetimeUtcString);
    return (
        <Button
            onClick={handleDelete} 
            label="Удалить"
            color="error"
            size="small"
            disabled={isSignedUp || appointmentDatetime < new Date()}
        >
            <Delete />
        </Button>
    );
};

// Компонент для отображения действий
const AppointmentActions = () => {
    const record = useRecordContext();
    if (!record || !record.id) return null;
    return (
        <DeleteAppointmentButton 
            appointmentId={record.id}
            scheduleId={record.schedule_id}
            isSignedUp={record.signedup}
            appointmentDatetimeUtcString={record.appointment_datetime}
        />
    );
};

const ListActions = () => {
    const navigate = useNavigate();
    const handleCreate = () => {
        navigate('/schedules/create');
    };
    
    return (
        <TopToolbar>
            <Button onClick={handleCreate} label="создать" startIcon={<Add />}/>
        </TopToolbar>
    );
};

export const ScheduleList = () => {
    const navigate = useNavigate();

    const doctorId = localStorage.getItem('currentDoctorId');
    const doctorFio = localStorage.getItem('currentDoctorFio');
    const filter = doctorId ? {doctor_id: doctorId} : {}

    const handleRowClick = (id, resource, record) => {
        navigate(`/schedules/${id}`);
        return false; // Предотвращаем стандартный переход
    }

    return (    
        <List
            filter={filter}
            title={`Расписания врача ${doctorFio}`}
            actions={<ListActions/>}
            sort={{ field: 'date_range.start', order: 'DESC' }}
            perPage={25}
        >
            <Datagrid 
                rowClick={handleRowClick}
                bulkActionButtons={false}
            >
                <DateField source="date_range.start" 
                    label="Начальная дата"
                    showTime
                >
                </DateField>
                <DateField source="date_range.end" 
                    label="Конечная дата"
                    showTime
                    options={{
                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                    }}
                >
                </DateField>
            </Datagrid>
        </List>
    )
}

export const ScheduleEdit = () => {
    const doctorFio = localStorage.getItem('currentDoctorFio');
    const EmptyToolbar = () => <Toolbar sx={{ display: 'none' }} />;
    return (
        <Edit title={`Расписание врача ${doctorFio}`}>
            <SimpleForm toolbar={<EmptyToolbar/>}>
                <NumberField source="schedule.price" label="Цена" transform={price => `Цена: ${price} рублей`}/>
                <ArrayField source="appointments">
                    <Datagrid 
                        bulkActionButtons={false}
                        rowClick={false}
                    >
                        <DateField source="appointment_datetime" label="Дата и время" showTime/>
                        <BooleanField source="signedup" label="Записаны"/>
                        <AppointmentActions />
                    </Datagrid>
                </ArrayField>
            </SimpleForm>
        </Edit>
    )
}

export const ScheduleCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();
    const transform = (data) => (
        {
            doctor_id: localStorage.getItem('currentDoctorId'),
            price: data.price,
            appointment_datetimes: data.appointment_datetimes.map(item => (new Date(item.datetime)).toISOString()),
        } 
    )
    const onSuccess = (response) => {
        notify('Расписание успешно создано', { type: 'success' });
        redirect('edit', 'schedules', response.id, response);
    }
    return (
        <Create title="Создание расписания" transform={transform} mutationOptions={{onSuccess}}>
            <SimpleForm>
                <NumberInput source="price" label="Цена" />
                <ArrayInput source="appointment_datetimes" label="Дата и время приемов">
                    <SimpleFormIterator>
                        <DateTimeInput source="datetime" label="Дата и время" required fullWidth/>
                    </SimpleFormIterator>
                </ArrayInput>
            </SimpleForm>
        </Create>
    );
};